import React from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem
} from 'reactstrap';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

class Menu extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        const {pathname} = this.props;

        return <Navbar color="dark" dark className="" expand="lg">
            <Link to={'/'} className="navbar-brand">
                <FontAwesomeIcon icon={faHome} color="#fcfcfc"/>
            </Link>
            <NavbarToggler onClick={this.toggle}/>
            <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                    <NavItem >
                        <Link to="/spatial-anchors" className="nav-link" style={{color: "#fcfcfc"}}> Spatial Anchors </Link>
                    </NavItem>
                    <NavItem>
                        <Link to="/items" className="nav-link" style={{color: "#fcfcfc"}}> Items </Link>
                    </NavItem>
                    <NavItem>
                        <Link to="/health-and-safety" className="nav-link" style={{color: "#fcfcfc"}}> Health and Safety </Link>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
    }
}

export default Menu;